import { gql } from "@apollo/client";
import { ReportJob } from "../fragments";

const FETCH_REPORT_JOB = gql`
  query FetchReportJob($id: Int!) {
    reportJob(id: $id) {
      ${ReportJob}
    }
  }
`;

const FETCH_REPORT_JOBS = gql`
  query FetchReportJobs($input: ReportJobFilterInput) {
    reportJobs(input: $input) {
      count
      edges {
        ${ReportJob}
      }
    }
  }
`;

const FETCH_EMAIL_REPORT_JOBS = gql`
  query FetchEmailReportJobs($input: ReportJobFilterInput) {
    reportJobs(input: $input) {
      count
      edges {
        id
        type
        report
        format
        filename
        completedAt
        contents {
          totalCount
          resolved
          items {
            id
            title
            subtitle
            thumbnailUrl
          }
        }
      }
    }
  }
`;

const FETCH_ADMIN_REPORT_JOBS = gql`
  query FetchAdminReportJobs($input: AdminReportJobFilterInput) {
    adminReportJobs(input: $input) {
      count
      edges {
        id
        userId
        correlationId
        type
        report
        format
        status
        progressCurrent
        progressTotal
        filename
        downloadUrl
        error
        attempts
        lastAttemptAt
        canRetry
        createdAt
        startedAt
        cancelRequestedAt
        cancelledAt
        completedAt
        owner {
          id
          email
          name
        }
      }
    }
  }
`;

export {
  FETCH_REPORT_JOB,
  FETCH_REPORT_JOBS,
  FETCH_EMAIL_REPORT_JOBS,
  FETCH_ADMIN_REPORT_JOBS,
};
